import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import userService from './userService'
import axios from 'axios'

// Get users
export const getUsers = createAsyncThunk('users', async (params: {}, thunkAPI) => {
  try {
    return await userService.getUsers({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetCampusAndSystem = createAsyncThunk('campus-and-system', async (_, thunkAPI) => {
  try {
    return await userService.campusAndSystemList()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSystemRoles = createAsyncThunk('system-roles', async (system_id: any, thunkAPI) => {
  try {
    return await userService.getSystemRoles(system_id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetCampusUnits = createAsyncThunk('system-roles', async (campus_id: any, thunkAPI) => {
  try {
    return await userService.getCampusUnits(campus_id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create user
export const createUser = createAsyncThunk('user-create', async (user: {}, thunkAPI) => {
  try {
    return await userService.createUser({user})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get user by id
export const getUserById = createAsyncThunk('get-user', async (id: string, thunkAPI) => {
  try {
    return await userService.getUserById(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Update user
export const updateUser = createAsyncThunk('user-update', async (user: {}, thunkAPI) => {
  try {
    return await userService.updateUser({user})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete user
export const deleteUser = createAsyncThunk('user-delete', async (user_id: string, thunkAPI) => {
  try {
    return await userService.deleteUser(user_id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Update user password
export const updateUserPassword = createAsyncThunk(
  'update-password',
  async (data: {}, thunkAPI) => {
    try {
      return await userService.updateUserPassword({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StartImpersonate = createAsyncThunk(
  'start-impersonate',
  async (data: {}, thunkAPI) => {
    try {
      return await userService.startImpersonate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response)
      }
    }
  }
)

// Stop Impersonation
export const StopImpersonate = createAsyncThunk('stop-impersonate', async (data: {}, thunkAPI) => {
  try {
    return await userService.stopImpersonate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const SetUserLanguage = createAsyncThunk('set-lang', async (id: string, thunkAPI) => {
  try {
    return await userService.setUserLanguage(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getStaffUsers = createAsyncThunk('users/staff-users', async (params: {}, thunkAPI) => {
  try {
    return await userService.getStaffUsers({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getLecturerUsers = createAsyncThunk(
  'users/lecturer-users',
  async (params: {}, thunkAPI) => {
    try {
      return await userService.getLecturerUsers({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStudentUsers = createAsyncThunk(
  'users/student-users',
  async (params: {}, thunkAPI) => {
    try {
      return await userService.getStudentUsers({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const staffStudentUserChangePassword = createAsyncThunk(
  'users/staff-student-user-change-password',
  async (data: {}, thunkAPI) => {
    try {
      return await userService.staffStudentUserChangePassword({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const staffStudentUserDelete = createAsyncThunk(
  'users/staff-student-user-delete',
  async (data: {}, thunkAPI) => {
    try {
      return await userService.staffStudentUserDelete({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const SetCampus = createAsyncThunk('update-user-campus', async (user: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/select-campus', user)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getSchoolStaffUsers = createAsyncThunk(
  'users/school-staff-users',
  async (params: {}, thunkAPI) => {
    try {
      return await userService.getSchoolStaffUsers({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getSchoolLecturerUsers = createAsyncThunk(
  'users/school-lecturer-users',
  async (params: {}, thunkAPI) => {
    try {
      return await userService.getSchoolLecturerUsers({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getSchoolStudentUsers = createAsyncThunk(
  'users/school-student-users',
  async (params: {}, thunkAPI) => {
    try {
      return await userService.getSchoolStudentUsers({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const schoolStaffStudentUserChangePassword = createAsyncThunk(
  'users/school-staff-student-user-change-password',
  async (data: {}, thunkAPI) => {
    try {
      return await userService.schoolStaffStudentUserChangePassword({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const schoolStaffStudentUserDelete = createAsyncThunk(
  'users/school-staff-student-user-delete',
  async (data: {}, thunkAPI) => {
    try {
      return await userService.schoolStaffStudentUserDelete({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const toggleUserStatus = createAsyncThunk(
  'users/toggle-status',
  async (data: {}, thunkAPI) => {
    try {
      return await userService.toggleUserStatus({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// User Types
type UserState = {
  errors: any
}

const initialState: UserState = {
  errors: '',
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(getUserById.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(createUser.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(updateUser.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(updateUserPassword.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
  },
})

export const {reset} = userSlice.actions
export default userSlice.reducer
